<template>
  <div>
    <div
      class="header-filters"
      :class="{ 'is-mobile-layout': isMobileLayout, 'is-mobile-show': show }"
    >
      <div class="d-flex">
        <!-- <div
          class="filter"
          :class="{ 'is-open': focusedFilter === 'categories' }"
          v-if="filtersData.categories && filtersData.categories.length > 0"
        >
          <multi-select
            :search="hasSearchInFilter(filtersData.categories)"
            :options="selectData.options"
            :select-options="filtersData.categories"
            @opened="openedMultiselect('categories')"
            @closed="closedMultiselect()"
            v-model="form['filter[c]']"
            :btn-label="$tc('category', 2)"
          />
        </div> -->
        <div
          class="filter"
          :class="{ 'is-open': focusedFilter === 'statuses' }"
          v-if="filtersData.statuses && filtersData.statuses.length > 0"
        >
          <multi-select
            :search="hasSearchInFilter(filtersData.statuses)"
            :options="selectData.options"
            :select-options="filtersData.statuses"
            @opened="openedMultiselect('statuses')"
            @closed="closedMultiselect()"
            v-model="form['filter[sn]']"
            :btn-label="$tc('status', 2)"
          />
        </div>
        <div
          class="filter"
          :class="{ 'is-open': focusedFilter === 'taskTypes' }"
          v-if="filtersData.taskTypes && filtersData.taskTypes.length > 0"
        >
          <multi-select
            :search="hasSearchInFilter(filtersData.taskTypes)"
            :options="selectDataTaskType.options"
            :select-options="filtersData.taskTypes"
            @opened="openedMultiselect('taskTypes')"
            @closed="closedMultiselect()"
            v-model="form['filter[tt]']"
            :btn-label="$tc('taskTypes', 2)"
          />
        </div>
        <div
          class="filter"
          :class="{ 'is-open': focusedFilter === 'tokenStandards' }"
          v-if="
            filtersData.tokenStandards && filtersData.tokenStandards.length > 0
          "
        >
          <multi-select
            :search="hasSearchInFilter(filtersData.tokenStandards)"
            :options="selectData.options"
            :select-options="filtersData.tokenStandards"
            @opened="openedMultiselect('tokenStandards')"
            @closed="closedMultiselect()"
            v-model="form['filter[ct]']"
            :btn-label="$tc('coinType', 2)"
          />
        </div>
        <div
          class="filter"
          :class="{ 'is-open': focusedFilter === 'managers' }"
          v-if="filtersData.managers && filtersData.managers.length > 0"
        >
          <multi-select
            :search="hasSearchInFilter(filtersData.managers)"
            :options="selectData.options"
            :select-options="filtersData.managers"
            @opened="openedMultiselect('managers')"
            @closed="closedMultiselect()"
            v-model="form['filter[m]']"
            :btn-label="$tc('manager', 2)"
          />
        </div>
        <div
          class="filter filter--calendar ml-0"
          :class="{ 'is-open': focusedFilter === 'endBeforeDate' }"
        >
          <div class="position-relative">
            <svg-icon
              v-if="focusedFilter === 'endBeforeDate'"
              icon="chevron-up"
              class="text-light icon-xs events-none"
            />
            <svg-icon
              v-else
              icon="chevron-down"
              class="text-light icon-xs events-none"
            />
            <input
              type="text"
              :placeholder="$t('endBefore')"
              :value="form['filter[eb]'] | formatDate"
              @focus="showCalendar('endBeforeDate')"
              @blur="closeCalendar('endBeforeDate')"
            />
          </div>
          <transition name="fade">
            <v-date-picker
              @mousedown.native.prevent
              :theme-styles="endBeforeDatePicker.theme.base"
              :input-props="{
                class: '',
                placeholder: $t('endBefore'),
                autocomplete: 'off'
              }"
              :formats="endBeforeDatePicker.formats"
              is-inline
              v-show="endBeforeDate"
              v-model="form['filter[eb]']"
            />
          </transition>
        </div>
        <div
          class="filter filter--calendar"
          :class="{ 'is-open': focusedFilter === 'endAfterDate' }"
        >
          <div class="position-relative">
            <svg-icon
              v-if="focusedFilter === 'endAfterDate'"
              icon="chevron-up"
              class="text-light icon-xs events-none"
            />
            <svg-icon
              v-else
              icon="chevron-down"
              class="text-light icon-xs events-none"
            />
            <input
              type="text"
              :placeholder="$t('endAfter')"
              :value="form['filter[ea]'] | formatDate"
              @focus="showCalendar('endAfterDate')"
              @blur="closeCalendar('endAfterDate')"
            />
          </div>
          <transition name="fade">
            <v-date-picker
              class="right"
              @mousedown.native.prevent
              :theme-styles="endAfterDatePicker.theme.base"
              :input-props="{
                class: '',
                placeholder: $t('endAfter'),
                autocomplete: 'off'
              }"
              :formats="endAfterDatePicker.formats"
              is-inline
              v-show="endAfterDate"
              v-model="form['filter[ea]']"
            />
          </transition>
        </div>
        <filter-reset @filters:reset="resetFilters" class="btn-reset" />
      </div>
    </div>
    <button-fixed-mobile
      @fixed-button:click="toggleMobileFilters()"
      :show="isMobileLayout"
    >
      <svg-icon v-if="show" icon="cross" />
      <svg-icon v-else icon="filter" />
    </button-fixed-mobile>
  </div>
</template>

<script>
import FilterReset from './FilterReset.vue';
import isEqual from 'js-isequal';
import cloneDeep from 'clone';
import ButtonFixedMobile from '@/components/ButtonFixedMobile.vue';
import { toUTCDate, toEndDate } from '@/utils/date.js';

export default {
  props: {
    filtersData: {
      type: Object,
      required: true
    }
  },

  components: {
    FilterReset,
    ButtonFixedMobile
  },

  data() {
    return {
      show: false,
      focusedFilter: '',
      endBeforeDate: false,
      endAfterDate: false,
      selectData: {
        options: {
          multi: true,
          labelName: 'name'
        }
      },
      selectDataTaskType: {
        options: {
          multi: true,
          labelName: 'name'
        }
      },
      endBeforeDatePicker: {
        value: '',
        theme: this.$config.datepicker
      },
      endAfterDatePicker: {
        value: '',
        theme: this.$config.datepicker
      },
      form: {
        'filter[c]': [],
        'filter[tt]': [],
        'filter[ct]': [],
        'filter[m]': [],
        'filter[sn]': [],
        'filter[eb]': null,
        'filter[ea]': null
      },
      formCopy: {
        'filter[c]': [],
        'filter[tt]': [],
        'filter[ct]': [],
        'filter[m]': [],
        'filter[sn]': [],
        'filter[eb]': null,
        'filter[ea]': null
      }
    };
  },

  computed: {
    isMobileLayout() {
      return (
        this.$root.screen.lg ||
        this.$root.screen.md ||
        this.$root.screen.sm ||
        this.$root.screen.xs
      );
    }
  },

  methods: {
    hasSearchInFilter(val) {
      return Array.isArray(val) && val.length > 9;
    },
    resetFilters() {
      Object.keys(this.form).forEach(el => {
        if (Array.isArray(this.form[el])) {
          this.form[el] = [];
        } else {
          this.form[el] = null;
        }
      });
    },
    openedMultiselect(val) {
      this.focusedFilter = val;

      // hack()
      setTimeout(() => {
        this.focusedFilter = val;
      }, 100);
    },
    closedMultiselect() {
      this.focusedFilter = '';
    },
    toggleMobileFilters() {
      this.show = !this.show;
    },
    showCalendar(name) {
      this[name] = true;
      this.openedMultiselect(name);
    },
    closeCalendar(name) {
      this.closedMultiselect();
      setTimeout(() => {
        this[name] = false;
      }, 100);
    }
  },

  watch: {
    form: {
      deep: true,
      handler(val) {
        if (isEqual(val, this.formCopy)) return;
        this.formCopy = cloneDeep(val);
        const emitingParams = {};

        Object.keys(val).forEach(el => {
          if (Array.isArray(val[el])) {
            emitingParams[el] = val[el].map(el => {
              return typeof el === 'object' && el !== null
                ? el.id
                : el.toLowerCase();
            });
          } else {
            emitingParams[el] = val[el];
          }
        });
        if (
          this.focusedFilter === 'endBeforeDate' ||
          this.focusedFilter === 'endAfterDate'
        ) {
          this.closeCalendar('endBeforeDate');
          this.closeCalendar('endAfterDate');
        }
        if (emitingParams['filter[eb]']) {
          emitingParams['filter[eb]'] = toEndDate(emitingParams['filter[eb]']);
          emitingParams['filter[eb]'] = toUTCDate(
            emitingParams['filter[eb]'],
            true
          );
        }
        if (emitingParams['filter[ea]']) {
          emitingParams['filter[ea]'] = toUTCDate(
            emitingParams['filter[ea]'],
            true
          );
        }
        this.$emit('campaign-filters:update', emitingParams);
      }
    }
  }
};
</script>

<style lang="scss">
.header-filters {
  width: 100%;

  .select {
    & > button {
      border-radius: 0 !important;
      height: 60px !important;
      line-height: 60px !important;
      max-height: 60px !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    .buttonLabel {
      padding: 0 !important;
    }
  }

  .filter {
    flex-grow: 1;
    margin: -1px;
  }

  .is-open {
    position: relative;
    z-index: 2;
  }

  .filter--calendar {
    // max-width: 135px;
    position: relative;

    .c-pane-container {
      position: absolute;
      top: 100%;
      margin-top: 10px;

      &.left {
        left: 0;
      }

      &.right {
        right: 0;
      }
    }

    &.is-open {
      & > .position-relative input {
        box-shadow: inset 0 0 0 1px $secondary;
        border-color: $secondary;
      }
    }

    .position-relative {
      height: 100%;

      .icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 14px;
      }

      & > input {
        height: 60px;
        margin: 0;
        background: none;
        border: none;
        height: 100%;
        padding: 15px;
        padding-right: 30px;
        border: 1px solid $border-color;
        border-right: 1px solid transparent;
        width: 100%;
        min-width: 130px !important;
        @extend %base-transition;

        &::placeholder {
          color: $body-color;
        }

        &:-ms-input-placeholder {
          color: $body-color;
        }

        &::-ms-input-placeholder {
          color: $body-color;
        }
      }
    }
  }

  .btn-reset {
    border: 1px solid $border-color;
    box-shadow: none;
    height: 60px;
    margin: -1px;
    margin-right: 0;
    border-right: 0;
  }
}

.header-filters {
  &.is-mobile-layout {
    transform: translateZ(0);
    position: fixed;
    right: -300px;
    bottom: 0;
    height: calc(100% - 77px);
    width: 300px;
    z-index: 1030;
    overflow-y: auto;
    background: $white;
    border-left: 1px solid $border-color;
    padding: 10px;
    -webkit-overflow-scrolling: touch;
    @extend %base-transition;

    &.is-mobile-show {
      transform: translateX(-300px);
    }

    .d-flex {
      display: block !important;
    }

    .filter {
      width: 100%;
      max-width: 100%;
      margin: 0;
      margin-bottom: 10px;

      .select > button {
        border: none;
        border-radius: $border-radius !important;
      }
    }

    .filter--calendar {
      width: 50%;
      float: left;

      input {
        border: none;
      }
    }

    .btn-reset {
      border: none;
      width: 100%;
    }
  }
}
</style>
